import { DEFAULT_POST_PAGE_FONT_SIZE_MOBILE, DEFAULT_POST_TITLE_FONT_SIZE_MOBILE } from '../constants/post-page';
import {
  CARD_BACKGROUND_COLOR,
  CARD_BORDER_COLOR,
  POST_TEXT_COLOR,
  POST_TITLE_FONT,
  POST_DESCRIPTION_FONT,
  BUTTON_TEXT_COLOR,
  BUTTON_COLOR,
  LINK_AND_HASHTAG_COLOR,
  APP_BACKGROUND_COLOR,
} from '@wix/communities-blog-client-common/dist/src/constants/wix-params';
import {
  PAGE_BACKGROUND_COLOR as MEMBERS_PAGE_BACKGROUND_COLOR,
  PAGE_TITLE_FONT,
  PAGE_LINK_FONT,
} from '../../member-pages-common/constants/wix-params';

const PAGE_BACKGROUND_COLOR = '#F0F4F7';
const BACKGROUND_COLOR = '#FFFFFF';
const DIVIDER_COLOR = '#E8ECF0';
const TEXT_COLOR = '#20303C';

const value = value => ({ value });
const font = (fontFamily, fontSize) => `font: normal normal normal ${fontSize}px/normal "${fontFamily}";`;
const titleFont = value(font('HelveticaNeueW10-75Bold', DEFAULT_POST_TITLE_FONT_SIZE_MOBILE));
const descriptionFont = value(font('HelveticaNeueW10-55Roma', DEFAULT_POST_PAGE_FONT_SIZE_MOBILE));

export default function getOneAppSettings(primaryColor) {
  return {
    style: {
      cssUrls: [],
      colors: {
        [CARD_BACKGROUND_COLOR]: value(BACKGROUND_COLOR),
        [CARD_BORDER_COLOR]: value(DIVIDER_COLOR),
        [POST_TEXT_COLOR]: value(TEXT_COLOR),
        [BUTTON_TEXT_COLOR]: value(BACKGROUND_COLOR),
        [BUTTON_COLOR]: value(primaryColor),
        [LINK_AND_HASHTAG_COLOR]: value(primaryColor),
        [APP_BACKGROUND_COLOR]: value(PAGE_BACKGROUND_COLOR),
        [MEMBERS_PAGE_BACKGROUND_COLOR]: value(PAGE_BACKGROUND_COLOR),
      },
      fonts: {
        [POST_TITLE_FONT]: titleFont,
        [PAGE_TITLE_FONT]: titleFont,
        [POST_DESCRIPTION_FONT]: descriptionFont,
        [PAGE_LINK_FONT]: descriptionFont,
      },
      googleFontsCssUrl: '',
      uploadFontFaces: '',
    },
  };
}
